// Core AUS constants and types
export const FANNIE_SYSTEM_TYPE = {
  DO: 'DO',
  DU: 'DU',
};

export const AUS_PROPERTY_KEYS = {
  FANNIE_USERNAME: 'FannieUsername',
  FANNIE_PASSWORD: 'FanniePassword',
  FANNIE_USE_DO: 'FannieUseDO',
  FREDDIE_USERNAME: 'FreddieLPAUsername',
  FREDDIE_PASSWORD: 'FreddieLPAPassword',
  FREDDIE_ROLE_TYPE: 'FreddiePartyRoleType',
  FREDDIE_ROLE_ID: 'FreddiePartyRoleIdentifier',
  FREDDIE_ROLE_TYPE_2: 'FreddiePartyRoleType2',
  FREDDIE_ROLE_ID_2: 'FreddiePartyRoleIdentifier2',
  FREDDIE_LCA_USERNAME: 'FreddieLCAUsername',
  FREDDIE_LCA_PASSWORD: 'FreddieLCAPassword',
  FREDDIE_SELLER_NUMBER: 'FreddieSellerNumber',
  FREDDIE_CREDIT_VENDOR_ID: 'FreddieCreditReportVendorIdentifier',
  FREDDIE_CREDIT_VENDOR_TECHNICAL_AFFILIATE_ID:
    'FreddieCreditReportVendorTechnicalAffiliateIdentifier',
};

export const FREDDIE_CREDIT_VENDOR_HELPER_TEXT =
  'Leave empty to use the default value for the credit provider.';

export const AUS_CREDENTIAL_PROPERTY_KEYS = new Set([
  AUS_PROPERTY_KEYS.FANNIE_PASSWORD,
  AUS_PROPERTY_KEYS.FREDDIE_PASSWORD,
  AUS_PROPERTY_KEYS.FREDDIE_LCA_PASSWORD,
]);
